import type { ILoginLocale } from '@/Pages/Onboard/Login/Locale/Login.locale';

const enUS: ILoginLocale = {
  title: 'Login in to {brand}',
  email: {
    label: 'Email',
    placeholder: 'example@email.com',
    error: 'Please enter a valid email address',
  },
  password: {
    label: 'Password',
    placeholder: 'Your password',
    error: 'Password is required',
  },
  passcode: {
    label: 'Authentication code',
    placeholder: '000000',
  },
  twoFactor: {
    title: 'Two-factor authentication',
    subtitle: 'Enter the 6-digit code from your authenticator app for {email}.',
  },
  button: {
    login: 'Login',
    forgotPassword: 'Forgot Password?',
    verify: 'Verify',
    back: 'Back',
  },
  terms: {
    message1: 'By logging in, you agree to',
    message2: ' our ',
    terms: 'Terms of Service',
    privacy: 'Privacy Policy',
  },
  errors: {
    invalidCredentials: 'Invalid email or password. Please try again.',
    accountLocked: 'Your account has been locked. Please contact support.',
    accountDisabled: 'Your account has been disabled. Please contact support.',
    networkError: 'Network error. Please check your connection and try again.',
    twoFactorRequired: 'Two-factor authentication required.',
    requiredPasscode: 'Enter your 6-digit two-factor authentication code.',
    invalidPasscode: 'Invalid two-factor code. Please try again.',
    blockedPassword: 'Account temporarily blocked. Please reset your password.',
    blockedTwoFactor: 'Too many invalid codes. Try again in {time}.',
    blockedTwoFactorToast: 'Too many invalid codes. Try again in a few minutes.',
    twoFactorBootstrapMissingToken: 'Two-factor setup token missing. Please log in again.',
  },
  cookieConsent: {
    necessary: 'Strictly Necessary Cookies',
    analytics: 'Analytics Cookies',
    necessaryDescription:
      'These cookies are essential for the website to function properly. They enable basic functions like page navigation and access to secure areas of the website. The website cannot function properly without these cookies.',
    analyticsDescription:
      'These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously. This data is used to improve the performance and user experience of our site.',
  },
};
export { enUS };
